import React from "react"
import { Link } from "react-router-dom"

import { Box, Typography } from "components/common/index"
import { jewlr_t } from "helpers/application"

import {
  SectionTitle,
  SectionSubTitle,
  Paragraph,
  PageTitle,
} from "./components"

const PrivacyNotice = () => (
  <Box contain fontWeight="light" lineHeight="copy" mb={1} pb={1}>
    <Box mt={4}>
      <PageTitle>Privacy Notice</PageTitle>
    </Box>
    <Box mb={10} px={{ _: 1, tablet: 0 }}>
      <SectionTitle>
        WHAT PERSONAL INFORMATION ABOUT CUSTOMERS DOES LEE FIORI COLLECT?
      </SectionTitle>
      <Paragraph>
        We collect your personal information in order to provide and continually
        improve our products and services. Here are the types of information we
        gather:
      </Paragraph>
      <Box py={{ _: 2, tablet: 0 }}>
        <SectionSubTitle>
          <li> Information You Give Us</li>
        </SectionSubTitle>
        <Paragraph>
          We receive and store any information you provide in relation to your
          order or any service you request. We collect contact information so
          that we can contact you for your service and delivery of your
          purchased products to you. You can choose not to provide certain
          information but then you might not be able to take advantage of many
          of our services
        </Paragraph>
        <SectionSubTitle>
          <li>Automatic Information</li>
        </SectionSubTitle>
        <Paragraph>
          We automatically receive and store certain types of information when
          you use Lee Fiori, such as information about your use, including your
          interaction with product and services available. Like many websites,
          we use cookies and other unique identifiers and we obtain certain
          types of information when your web browser or device accesses Lee
          Fiori websites (i.e. leefiori.com, leefiori.ca, etc.) and other
          content served by or on behalf of Lee Fiori
        </Paragraph>
        <SectionSubTitle>
          <li>Information From Other Sources</li>
        </SectionSubTitle>
        <Paragraph>
          We might receive information about you from other sources. Examples of
          information we receive from other sources include updated delivery and
          address information from our carriers.
        </Paragraph>
      </Box>
      <SectionTitle>
        FOR WHAT PURPOSES DOES LEE FIORI PROCESS YOUR PERSONAL INFORMATION?
      </SectionTitle>
      <Paragraph>
        We process your personal information to operate, provide, and improve
        our offerings to our customers. These purposes include:
      </Paragraph>
      <SectionSubTitle>
        <li> Provide functionality, troubleshoot, and improve.</li>
      </SectionSubTitle>
      <Paragraph>
        We use your personal information to provide functionality, analyse
        performance, fix errors, and improve usability and effectiveness of our
        products and services.
      </Paragraph>
      <SectionSubTitle>
        <li>Recommendations and personalisation. </li>
      </SectionSubTitle>
      <Paragraph>
        We use your personal information to recommend features, products, and
        services that might be of interest to you, identify your preferences,
        and personalise your experience with Lee Fiori.
      </Paragraph>
      <SectionSubTitle>
        <li> Comply with legal obligations.</li>
      </SectionSubTitle>
      <Paragraph>
        In certain cases, we have a legal obligation to collect and process your
        personal information.
      </Paragraph>
      <SectionSubTitle>
        <li> Advertising.</li>
      </SectionSubTitle>
      <Paragraph>
        To serve you interest-based ads, we use information such as your
        interactions with Lee Fiori’s site, content, products or services. We do
        not use personally identifiable information such as name or e-mail to
        serve interest-based ads. As is common in the advertising industry, we
        use cookies, pixels, and other technologies (collectively,
        &quot;cookies&quot;), which enable us to understand the effectiveness of
        the interest-based ads we show you by measuring what ads are clicked or
        viewed, and to provide you with more useful and relevant ads.
      </Paragraph>
      <SectionSubTitle>
        <li>Fraud Prevention and Credit Risks.</li>
      </SectionSubTitle>
      <Paragraph>
        We process personal information to prevent and detect fraud and abuse in
        order to protect the security of our customers, and Lee Fiori, and
        others. We may also use scoring methods to assess and manage credit
        risks.
      </Paragraph>
      <SectionSubTitle>
        <li>Purposes for which we seek your consent.</li>
      </SectionSubTitle>
      <Paragraph>
        We may also ask for your consent to process your personal information
        for a specific purpose that we communicate to you. When you consent to
        our processing your personal information for a specified purpose, you
        may withdraw your consent at any time and we will stop processing of
        your data for that purpose
      </Paragraph>
      <SectionTitle>WHAT ABOUT COOKIES?</SectionTitle>
      <Paragraph pb={{ _: 2, tablet: 0 }}>
        To enable our systems to recognise your browser or device and to provide
        services to you, we use cookies. Please read more about cookies in our{" "}
        <Link style={{ textDecoration: "underline" }} to="/privacy-policy">
          Privacy Policy
        </Link>
      </Paragraph>
      <SectionTitle>
        DOES LEE FIORI SHARE YOUR PERSONAL INFORMATION?
      </SectionTitle>
      <Paragraph>
        Information about our customers is an important part of our business and
        we are not in the business of selling personal information to others.
        Lee Fiori shares information only as described below where the recipient
        is either subject to this Privacy Notice or follow practices at least as
        protective as those described in this Privacy Notice.
      </Paragraph>
      <SectionSubTitle>
        <li>Third Party Service Providers:</li>
      </SectionSubTitle>
      <Paragraph>
        We employ other companies and individuals to perform functions on our
        behalf. Examples include fulfilling orders for products or services,
        delivering packages, sending postal mail and e-mail, removing repetitive
        information from customer lists, analysing data, providing marketing
        assistance, providing search results and links (including paid listings
        and links), processing payments, transmitting content, scoring credit
        risk, and providing customer service. These third-party service
        providers have access to personal information needed to perform their
        functions, but are not permitted to use it for other purposes. Further,
        they must process the personal information in accordance with this
        Privacy Notice and as permitted by applicable data protection laws.
      </Paragraph>
      <SectionSubTitle>
        <li>Business Transfers:</li>
      </SectionSubTitle>
      <Paragraph>
        As we continue to develop our business, we might sell or buy other
        businesses or services. In such transactions, customer information may
        be one of the transferred business assets but remains subject to the
        promises made in any pre-existing Privacy Notice (unless the customer
        consents otherwise). Also, in the unlikely event that Lee Fiori. or
        substantially all of its assets are acquired, customer information will
        be one of the transferred assets.
      </Paragraph>
      <SectionSubTitle>
        <li>Protection of Lee Fiori and Others:</li>
      </SectionSubTitle>
      <Paragraph>
        We release account and other personal information when the release is to
        comply with the law; enforce or apply our Terms and Conditions
      </Paragraph>
      <SectionSubTitle>
        <li> Other than as set out above:</li>
      </SectionSubTitle>
      <Paragraph>
        You will receive notice when personal information about you might be
        shared with third parties and you will have an opportunity to choose not
        to share the information.
      </Paragraph>
      <SectionSubTitle>
        Transfers out of the European Economic Area.
      </SectionSubTitle>
      <Paragraph>
        Whenever we transfer personal information to countries outside of the
        European Economic Area in the course of sharing information as set out
        above, we will ensure that the information is transferred in accordance
        with this Privacy Notice and as permitted by the applicable laws on data
        protection.
      </Paragraph>
      <SectionTitle>HOW SECURE IS INFORMATION ABOUT ME?</SectionTitle>
      <Paragraph>
        We design our systems with your security and privacy in mind.
      </Paragraph>
      <Paragraph>
        <li>
          We work to protect the security of your information during
          transmission by using Secure Sockets Layer (SSL) software, which
          encrypts information you input.
        </li>
        <li>
          We follow the Payment Card Industry Data Security Standard (PCI DSS)
          when handling credit card data.
        </li>
        <li>
          We maintain physical, electronic and procedural safeguards in
          connection with the collection, storage and disclosure of personal
          customer information. Our security procedures mean that we may
          occasionally request proof of identity before we disclose personal
          information to you.
        </li>
        <li>
          It is important for you to protect against unauthorised access to your
          password and to your computers, devices, and applications. Be sure to
          sign off when you finish using a shared computer.
        </li>
      </Paragraph>
      <SectionTitle>
        WHAT ABOUT THIRD-PARTY ADVERTISERS AND LINKS TO OTHER WEBSITES?
      </SectionTitle>
      <Paragraph>
        Lee Fiori may include third-party advertising and links to other
        websites and apps. Third party advertising partners may collect
        information about you when you interact with their content, advertising,
        and services.
      </Paragraph>
      <SectionTitle>WHAT INFORMATION CAN I ACCESS?</SectionTitle>
      <Paragraph>
        You can access your purchase history in the &quot;My Account&quot;
        section of the website.
      </Paragraph>
      <SectionTitle>WHAT CHOICES DO I HAVE?</SectionTitle>
      <Paragraph>
        If you have any questions or objection as to how we collect and process
        your personal information, please send an email to privacy@leefiori.com.
      </Paragraph>
      <Paragraph>
        <li>
          As described above, you can choose not to provide certain information
          but then you might not be able to take advantage of some of our
          offerings and services.
        </li>
        <li>
          You can add or update certain information on our self service portal,
          on your account page or by contacting customer service. When you
          update information, we usually keep a copy of the previous version for
          our records.
        </li>
        <li>
          If you no longer want to receive e-mail or other communications from
          us, you can opt-out from any email you’ve received from us.
        </li>
        <li>
          The Help feature on most browsers and devices will tell you how to
          prevent your browser or device from accepting new cookies, how to have
          the browser notify you when you receive a new cookie or how to disable
          cookies altogether. Because cookies allow you to take advantage of
          some essential information we recommend that you leave them turned on.
          For instance, if you block or otherwise reject our cookies, you will
          not be able to add items to your Cart, proceed to Checkout, or use
          your account page, self serve portal or any page that require you to
          sign in.
        </li>
        <li>
          If you want to browse our websites anonymously, you may do so by
          disabling cookies on your browser.
        </li>
      </Paragraph>
      <Paragraph>
        In addition, subject to applicable law, you have the right to request
        access to, correct, and delete your personal data, and to ask for data
        portability. You may also object to our processing of your personal data
        or ask that we restrict the processing of your personal data in certain
        instances. If you wish to do any of these things, please contact
        Customer Service or email{" "}
        <Typography
          as="a"
          fontSize={16}
          href="mailto:heythere@leefiori.com"
          underline
        >
          heythere@leefiori.com
        </Typography>
        .
      </Paragraph>
      <SectionTitle>
        HOW LONG DO WE KEEP YOUR PERSONAL INFORMATION?
      </SectionTitle>
      <Paragraph>
        We keep your personal information to enable your continued use of Lee
        Fiori, for as long as it is required in order to fulfil the relevant
        purposes described in this Privacy Notice, as may be required by law
        such as for tax and accounting purposes, or as otherwise communicated to
        you. For example, we retain your transaction history so that you can
        review past purchases (and repeat orders if desired) and what addresses
        you have shipped orders to, and to improve the relevancy of products and
        content we recommend.
      </Paragraph>
      <SectionTitle>CONTACTS, NOTICES & REVISIONS</SectionTitle>
      <Paragraph>
        If you have any concern about privacy at Lee Fiori or want to contact
        one of our data controllers, please contact privacy@leefiori.com with a
        thorough description and we will try to resolve the issue for you. Our
        business changes constantly and our Privacy Notice will change also. You
        should check our website frequently to see recent changes. Unless stated
        otherwise, our current Privacy Notice applies to all information that we
        have about you and your account. We stand behind the promises we make,
        however, and will never materially change our policies and practices to
        make them less protective of customer information collected in the past
        without the consent of affected customers.
      </Paragraph>
      <SectionTitle>EXAMPLES OF INFORMATION COLLECTED</SectionTitle>
      <SectionSubTitle>
        Information You Give Us When You use Lee Fiori:{" "}
      </SectionSubTitle>
      <Paragraph>
        <li>search for products or services;</li>
        <li>place an order on Lee Fiori;</li>
        <li>
          download, stream, view, or use content on a device, or through a
          service or application on a device;
        </li>
        <li>
          provide information in your account (and you might have more than one
          if you have used more than one e-mail address or mobile number when
          shopping with us)
        </li>
        <li>communicate with us by phone, e-mail, or otherwise;</li>
        <li>
          complete a questionnaire, a support ticket, or a contest entry form;
        </li>
        <li>upload images, videos or other files;</li>
        <li>
          participate in community features, provide and rate customer reviews;
        </li>
        <li>
          employ product status alerts, such as Order Notifications or{" "}
          {jewlr_t("terms.Shipping")} Notifications.
        </li>
      </Paragraph>
      <Paragraph>
        As a result of those actions, you might supply us with such information
        as: your name; address and phone number; payment information; your
        location information; people to whom purchases have been dispatched
        (including addresses and phone numbers); e-mail addresses of your
        friends and other people; content of reviews and e-mails to us; personal
        description and photograph; images and videos uploaded or emailed to us,
        information and documents regarding identity and standing; credit
        history information.
      </Paragraph>
      <SectionTitle>AUTOMATIC INFORMATION</SectionTitle>
      <Paragraph>
        Examples of the information we collect and analyse include:
      </Paragraph>
      <Paragraph>
        <li>
          the Internet protocol (IP) address used to connect your computer to
          the Internet;
        </li>
        <li>login; e-mail address; password;</li>
        <li>the location of your device or computer;</li>
        <li>
          content interaction information, such as content downloads, streams,
          and playback details network details, including information about your
          internet service provider;
        </li>
        <li>
          Lee Fiori metrics (e.g., the occurrences of technical errors, your
          interactions with service features and content, your settings
          preferences and backup information, location of your device running an
          application, information about uploaded images and files (e.g., file
          name, dates, times and location of your images));
        </li>
        <li>
          purchase and content use history, which we sometimes aggregate with
          similar information from other customers to create features such as
          Best Sellers;
        </li>
        <li>
          the full Uniform Resource Locators (URL) clickstream to, through and
          from our website (including date and time); cookie number; products
          and/ or content you viewed or searched for; page response times,
          download errors, length of visits to certain pages, page interaction
          information (such as scrolling, clicks, and mouse-overs),
        </li>
        <li>phone numbers used to call our customer service number.</li>
      </Paragraph>
      <Paragraph>
        We may also use device identifiers, cookies, and other technologies on
        devices, applications and our web pages to collect browsing, usage or
        other technical information for fraud prevention purposes
      </Paragraph>
      <SectionTitle>INFORMATION FROM OTHER SOURCES</SectionTitle>
      <Paragraph>
        Examples of information we receive from other sources include:
      </Paragraph>
      <Paragraph>
        <li>
          updated delivery and address information from our carriers or other
          third parties, which we use to correct our records and deliver your
          next purchase or communication more easily;
        </li>
      </Paragraph>
      <SectionTitle>INFORMATION YOU CAN ACCESS</SectionTitle>
      <Paragraph>
        Examples of information you can access through Lee Fiori include:
      </Paragraph>
      <Paragraph>
        <li>status of recent orders;</li>
        <li>your complete order history;</li>
        <li>
          personally identifiable information (including name, e-mail, address,
          phone);
        </li>
        <li>Wish Lists and Cart information;</li>
      </Paragraph>
      <SectionTitle>INTEREST BASED ADS</SectionTitle>
      <Paragraph>
        <li>
          To serve you interest-based ads, we use information such as your
          interactions with Lee Fiori sites, content, products or services. We
          do not use personally identifiable information such as name or e-mail
          to serve interest-based ads. As is common in the advertising industry,
          we use cookies, pixels, and other technologies (collectively,
          &quot;cookies&quot;), which enable us to understand the effectiveness
          of the interest-based ads we show you by measuring what ads are
          clicked or viewed, and to provide you with more useful and relevant
          ads. For example, if we know what ads are shown to your browser we can
          be careful not to show the same ads repeatedly.
        </li>
      </Paragraph>
      <SectionTitle>CALIFORNIA CONSUMER PRIVACY ACT (CCPA)</SectionTitle>
      <Paragraph>
        This California Consumer Privacy Act disclosure section
        (&quot;Disclosure&quot;) supplements the Lee Fiori’s Privacy Policy and
        is effective as of July 1, 2020.
      </Paragraph>
      <Paragraph>
        The Lee Fiori Privacy Policy describes the personal information that we
        collect, the sources from which we collect it, the purposes for which we
        use it, the limited circumstances under which we share personal
        information, and with whom we share it. These additional disclosures are
        required by the California Consumer Privacy Act:
      </Paragraph>
      <SectionSubTitle>
        1. Categories of personal information collected
      </SectionSubTitle>
      <Paragraph>
        The personal information that Lee Fiori collects, or has collected from
        consumers in the twelve months prior to the effective date of this
        Disclosure, fall into the following categories established by the
        California Consumer Privacy Act.
      </Paragraph>
      <Paragraph>
        <li>
          identifiers such as your name, alias, address, phone numbers, email,
          or IP address;
        </li>
        <li>
          inference data, such as information about your purchase preferences;
        </li>
        <li>
          geolocation data, such as the location of your device or computer;
        </li>
        <li>purchase activity</li>
        <li>
          visual information such as photos uploaded for photo box or photo
          pendant
        </li>
        <li>
          information such as age, gender, or other protected classifications,
        </li>
        <li>commercial information, such as purchase activity;</li>
        <li>audio or visual information, such as images and videos</li>
      </Paragraph>
      <SectionSubTitle>
        2. Categories of personal information NOT collected by Lee FIori
      </SectionSubTitle>
      <Paragraph>Lee Fiori does not collect your credit card number.</Paragraph>
      <SectionSubTitle>
        3. Categories of personal information disclosed for a business purpose
      </SectionSubTitle>
      <Paragraph>
        The personal information that Lee Fior disclosed about consumers for a
        business purpose in the twelve months prior to the effective date of
        this Disclosure fall into the following categories established by the
        California Consumer Privacy Act:
      </Paragraph>
      <Paragraph>
        <li>
          identifiers such as your name, address, phone numbers, or IP address,
          for example if we use a third-party carrier to deliver your order;
        </li>
        <li>
          your age, gender, or other protected classifications, for example if
          you choose to participate in a survey;
        </li>
        <li>
          commercial information, such as the details of a product or service
          you purchased if a third-party service provider is assisting to
          provide that product or service to you;
        </li>
        <li>
          internet or other electronic network activity information, such as if
          we use a service provider to help us manage against fraud;
        </li>
        <li>
          geolocation data, such as providing a delivery partner information
        </li>
        <li>
          audio or visual information, for example if a service provider reviews
          recordings of customer service phone calls for quality assurance
          purposes,
        </li>
      </Paragraph>
      <SectionSubTitle>
        4. Right to Request Access to or Deletion of Personal Information
      </SectionSubTitle>
      <Paragraph>
        California residents have a right under the California Consumer Privacy
        Act to request information about the collection of your personal
        information by Lee Fiori, or access of or deletion of your personal
        information. If you wish to do any of these things, please contact
        privacy@leefiori.com Depending on your data choices, certain services
        may be limited or unavailable. You can make a request one time each
        year, by emailing us. Please mention in your letter that you are making
        a &quot;California Shine the Light&quot; inquiry. We will respond within
        30 days.
      </Paragraph>
      <SectionSubTitle>5. No sale of personal information</SectionSubTitle>
      <Paragraph>
        In the twelve months prior to the effective date of this Disclosure, Lee
        Fiori has not sold any personal information of consumers, as those terms
        are defined under the California Consumer Privacy Act.
      </Paragraph>
      <SectionSubTitle>6. No Discrimination</SectionSubTitle>
      <Paragraph>
        Lee Fiori will not discriminate against any consumer for exercising
        their rights under the California Consumer Privacy Act.
      </Paragraph>
    </Box>
  </Box>
)

export default PrivacyNotice
